// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"quote-module--wrapper--2U9Hn","quote":"quote-module--quote--u_mJn","author":"quote-module--author--3CTC4"};